<h2 mat-dialog-title translate>Reenvío de link</h2>
<mat-divider class="dialog__divider--top"></mat-divider>
<mat-dialog-content>
  <div class="content_dialog">
    <p>Se va a reenviar el link, ¿a dónde quieres que se reenvíe?</p>
  </div>
</mat-dialog-content>
<mat-divider class="dialog__divider--bottom"></mat-divider>
<mat-dialog-actions align="center">
  <button id="sendPhoneButton" *ngIf="!phone" mat-flat-button color="accent" class="btnMobile" (click)="sendToPhone()">
    <span translate>Teléfono</span>
  </button>
  <button id="sendEmailButton" *ngIf="!email" mat-flat-button color="accent" class="btnMobile" (click)="sendToEmail()">
    <span translate>Email</span>
  </button>
</mat-dialog-actions>
